import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  OverLayData,
  truncateString,
} from "../../ReUseFunctions/ReuseFunctions";
import { handleScroll } from "../../OnScrollLoading";

export default function BranchTable(props) {
  return (
    <div>
      <div className="sb-table-div sb-table-setion">
        <Paper
          sx={{ width: "100%", overflow: "hidden" }}
          className="table-main-div"
        >
          <TableContainer
            onScroll={(e) =>
              handleScroll(
                e,
                props.tableData,
                props.totalData,
                props.setLoading,
                props.setPageSize,
                props.PageSize
              )
            }
          >
            <Table
              stickyHeader
              aria-label="sticky table table-responsive"
              className="branch-table"
            >
              <TableHead className="custom-table-header">
                <TableRow>
                  {props.tableHeader.map((data, i) => (
                    <TableCell key={i} align={data?.align}>
                      {data?.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.tableData.map((data, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <div>
                        <div>
                          <strong className="color-green">{data?.name}</strong>
                        </div>
                        <div className="color-yellow">
                          BR-{data?.branch_code}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div>
                        <div>
                          <b>Name : </b>
                          {data?.point_of_Contact}
                        </div>
                        <div>
                          <b>Mobile :</b> {data?.mobile}
                        </div>
                        <div>
                          <b>Email :</b> {data?.email}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>{data?.country}</TableCell>
                    <TableCell>{data?.zone}</TableCell>
                    <TableCell>{data?.state}</TableCell>
                    <TableCell>{data?.city}</TableCell>
                    <TableCell style={{ maxWidth: "200px" }}>
                      <div>
                        {truncateString(data?.location, 60)}
                        &nbsp;
                        <OverLayData data={data?.location} />
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className={`${data.status}-status`}>
                        <span className="status-text">{data?.status}</span>
                      </div>
                    </TableCell>
                    <TableCell align="center">
                      <div className="edit-view-link">
                        <div
                          className="edit-icon-text"
                          onClick={() => {
                            props.openCloseAddEditModel();
                            props.setBranchID(data.branch_code);
                          }}
                        >
                          <span className="hv-center">
                            <i className="fa fa-edit" />
                            Edit
                          </span>
                        </div>
                        {/* <div className="view-icon-text">
                          <span className="hv-center">
                            <i className="fa fa-eye" />
                            View
                          </span>
                        </div> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </div>
  );
}
